import style from './index.module.scss';

type TTextBanner = {
  title: string;
  text: string | JSX.Element;
};

export const TextBanner = ({ title, text }: TTextBanner) => {
  return (
    <div className={style.content}>
      <p className={style.title}>{title}</p>
      <p className={style.text} dangerouslySetInnerHTML={{ __html: text }} />
    </div>
  );
};
